import { Component, Inject, ViewEncapsulation, ElementRef, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { Session } from 'protractor';
import { PdfService } from '../../../services/pdf.services';
import { CommonService } from '../../../services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StatesService } from '../../../services/states.service';
import { FormsByStatesDataModel } from '../../../variables/states';
import { CustomerService } from '../../../services/customer.service';
import { ClaimType } from '../../../variables/claim-type';
import { AuthService } from '../../../services/auth.service';
import { CertificateDataModel, CertificateModel, FilledInResultDataModel, CertificateModelForAttachment } from '../../../variables/customer';
import { HTMLWithRulesDataModel, HTMLValidationDataModel } from '../../../variables/form';
import { Location } from '@angular/common';





const prefillPdfTemp = async (pdfService: PdfService, certificate: CertificateModel): Promise<FilledInResultDataModel> => {

  let data = await pdfService.prefillPdfTemp(certificate)
    .toPromise()
    .catch(error => {
      console.log(error);
      if (error.message != undefined && error.message != "") {
        alert(error.message);
      }
    });

  if (data instanceof Object) {
    let result = data["result"];
    let f = result["file"];
    let base64 = f.fileContents;
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));
    var i = 0;
    for (i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }


    const blob = new Blob([array], { type: 'application/pdf' });
    console.log(window.URL.createObjectURL(blob));
    let finaldata: FilledInResultDataModel = <FilledInResultDataModel>{
      url: window.URL.createObjectURL(blob),
      fileName: result["fileName"],
      referenceNumber: result["referenceNumber"]
    };

    return finaldata;
  }

  return null;
}


const prefillPdf = async (pdfService: PdfService, certificate: CertificateModel): Promise<FilledInResultDataModel> => {

  let data = await pdfService.prefillPdf(certificate)
    .toPromise()
    .catch(error => {
      if (error.message != undefined && error.message != "") {
        alert(error.message);
      }
    });

  if (data instanceof Object) {
    let result = data["result"];
    let f = result["file"];
    let base64 = f.fileContents;
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));
    var i = 0;
    for (i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }


    const blob = new Blob([array], { type: 'application/pdf' });
    console.log(window.URL.createObjectURL(blob));
    let finaldata: FilledInResultDataModel = <FilledInResultDataModel>{
      url: window.URL.createObjectURL(blob),
      fileName: result["fileName"],
      referenceNumber: result["referenceNumber"]
    };

    return finaldata;
  }

  return null;
}


const getHtml = async (pdfService: PdfService, formName: string, stateName: string, isEsign?: boolean): Promise<string> => {

  let response = await pdfService.getHtml(formName, stateName, isEsign).toPromise()
    .catch(error => {
      console.log(error);
    });
  if (response instanceof Object) {
    if (response["data"] != undefined) {
      return response["data"];
    }
    else {
      if (response["message"] != "")
        alert(response["message"]);
    }
  }
}

const getFormById = async (statesService: StatesService, id: number): Promise<FormsByStatesDataModel> => {

  let response = await statesService.getFormById(id)
    .toPromise()
    .catch(error => {
      if (error instanceof Object) {
        if (error["message"] != "") {
          alert(error["message"]);
        }
      }
      console.log(error);
    });
  if (response instanceof Object) {
    if (response["message"] != "" && response["message"] != undefined) {
      alert(response["message"]);
    }
    if (response instanceof Object) {
      if (response["message"] != "" && response["message"] != undefined) {
        alert(response["message"]);
      }
      let result = <FormsByStatesDataModel>response["result"];

      return result;
    }
    return null;
  }

}

//HTML RULES
const getHTMLWithRules = async (pdfService: PdfService, formName: string, stateName: string, formType?: string): Promise<HTMLWithRulesDataModel> => {

  let response = await pdfService.getHTMLRules(formName, stateName, formType).toPromise()
    .catch(error => {
      if (error instanceof Object) {
        if (error["message"] != "") {
          alert(error["message"]);
        }
      }
      console.log(error);
    });
  if (response instanceof Object) {
    console.log("OBJ");
    if (response["message"] != "" && response["message"] != undefined) {
      alert(response["message"]);
    }

    if (response instanceof Object) {
      if (response["message"] != "" && response["message"] != undefined) {
        alert(response["message"]);
      }
      let result = <HTMLWithRulesDataModel>response["result"];

      return result;
    }
    return null;
  }

}

const approveFillIn = async (pdfService: PdfService, referenceNumber: any): Promise<any> => {

  let response = await pdfService.approveFillIn(referenceNumber)
    .toPromise()
    .catch(error => {
      if (error instanceof Object) {
        if (error["message"] != "") {
          alert(error["message"]);
        }
      }
      console.log(error);
    });
  if (response instanceof Object) {
    if (response["message"] != "" && response["message"] != undefined) {
      alert(response["message"]);
    }
    if (response instanceof Object) {
      let result = response["result"];

      return result;
    }
    return null;
  }

}

@Component({
  selector: 'app-fill-in',
  templateUrl: './fill-in.component.html',
  styleUrls: ['./fill-in.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FillInComponent {
  sourceFolder = "/assets/blankforms/";
  dateNow: string = (new Date()).toLocaleDateString();
  dateTimeNow: Date = new Date();

  formId: number = null;

  //destinationFile: string = "";
  destinationFile: SafeResourceUrl;

  fileName: string = "";
  formName: string = "";
  state: string = "";
  templateName: string = "";
  formHtml: SafeHtml;
  esignHtml: SafeHtml;


  data: CertificateDataModel[] = [];

  signatureForm: UntypedFormGroup;
  signatureSubmitted: boolean = false;
  emptySignaturePad: string = "";

  consentForm: UntypedFormGroup;
  consentSubmitted: boolean = false;

  isSummary: boolean = false;
  referenceNumber: string = "";
  emailRecipient: string = "";
  newFileName: string = "";

  isWait: boolean = false;

  htmlRules: HTMLValidationDataModel[];
  //public viewElement: ElementRef;
  //public element: any;
  hasErrors: boolean = false;
  isLoading: boolean = false;
  apiFormType: string = "";
  totalCost = 0;
  additionalPdfFile: any = null;
  attachAdditionalPdf: boolean = false;
  showAttachPdfSection: boolean = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private pdfService: PdfService,
    public commonService: CommonService,
    public sanitizer: DomSanitizer,
    private activeModal: NgbModal,
    private customerService: CustomerService,
    private authService: AuthService,
    statesService: StatesService,
    route: ActivatedRoute,
    router: Router,
    private _ngZone: NgZone,
    public location: Location
  ) {
    this.formId = parseInt(route.snapshot.params["id"]);
    if (this.formId != undefined && this.formId != null) {
      getFormById(statesService, this.formId).then(data => {
        if (data != undefined && data != null) {
          this.state = data.state;
          this.formName = data.form;
          if (data?.formType == "EXEMPT") {
            this.templateName = this.state + "_E_" + this.formName;
          } else {
            this.templateName = this.state + "_" + this.formName;
          }
          this.fileName = this.templateName + ".pdf";
          this.apiFormType = data?.formType;

          this.attachAdditionalPdf = (this.state === 'AZ' && this.formName === '5000HC' && this.formId == 150) ||
            (this.state === 'CT' && this.formName === 'CERT119' && this.formId == 48) ||
            (this.state === 'MA' && this.formName === 'ST5' && this.formId == 80) ||
            (this.state === 'MI' && this.formName === '3372' && this.formId == 2) ||
            (this.state === 'MI' && this.formName === '3372' && this.formId == 66) ||
            (this.state === 'MO' && this.formName === '149' && this.formId == 3) ||
            (this.state === 'MO' && this.formName === '149' && this.formId == 313) ||
            (this.state === 'PA' && this.formName === 'REV_1220' && this.formId == 7) ||
            (this.state === 'PA' && this.formName === 'REV_1220' && this.formId == 312) ||
            (this.state === 'PA' && this.formName === 'REV_1715' && this.formId == 242) ||
            (this.state === 'SD' && this.formName === 'STREAMLINE' && this.formId == 138) ||
            (this.state === 'SD' && this.formName === 'STREAMLINE' && this.formId == 137) ||
            (this.state === 'WA' && this.formName === '360001' && this.formId == 310) ||
            (this.state === 'AZ' && this.formName === '5000A' && this.formId == 12);
          //let _file: string = this.sourceFolder + this.fileName;
          //this.destinationFile = this.sanitizer.bypassSecurityTrustResourceUrl(_file);
          //getHtml(pdfService, this.formName).then(result => {
          getHTMLWithRules(pdfService, this.formName, this.state, data?.formType).then(result => {
            if (result != undefined && result != null) {

              this.formHtml = this.sanitizer.bypassSecurityTrustHtml(result["html"]);

              window['counterComponent'] = { component: this, zone: this._ngZone };
              this.htmlRules = result["htmlrules"];

              if (this.formId == 12) {
                setTimeout(() => this.setupAttachPdfCheckboxWatchers(), 0);
              }
            }
            else {
              alert("Form is not available. Please contact support.");
              router.navigate(["/eCert/certificates"]);
            }
          });

          getHtml(pdfService, this.formName, this.state, true).then(result => {
            if (result != undefined && result != null && result != "") {
              this.esignHtml = this.sanitizer.bypassSecurityTrustHtml(result);
            }
          });
          this.signatureForm = this.formBuilder.group({
            personSigning: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
            personTitle: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
            signatureData: ['', Validators.required]
          });

          this.consentForm = this.formBuilder.group({
            hasConsent: [false, Validators.requiredTrue]
          });

          let _certificate: CertificateModel = {
            templateName: this.templateName,
            dateSubmitted: this.dateTimeNow,
            formId: this.formId,
            data: null
          };
          prefillPdfTemp(pdfService, _certificate).then(result => {
            //this.destinationFile = result.url;
            this.destinationFile = this.sanitizer.bypassSecurityTrustResourceUrl(result.url);
          });
        }
        else {
          router.navigate(["/eCert/certificates"]);
        }
      });
    }



  }

  get sf() { return this.signatureForm.controls; }

  get cf() { return this.consentForm.controls; }

  //getDestinationFile() {
  //  return this.sanitizer.bypassSecurityTrustResourceUrl(this.destinationFile);
  //}


  //HTML RULES
  checkHTMLRules() {
    let message = "";
    let blnValid = true;
    let firstInvalidElement: HTMLElement = null;

    // Remove any old error borders
    document.querySelectorAll(".error-border").forEach((el) => {
      el.classList.remove("error-border");
    });

    if (this.htmlRules.length > 0) {
      for (var rule of this.htmlRules) {
        if (rule.isRequired) {
          let input = document.getElementById(rule.pdfFieldName) as HTMLInputElement;

          if (input) {
            // Skip disabled inputs completely
            if (input.disabled) continue;

            if (input.type === "text" || input.type === "date") {
              if (!input.value || input.value.trim() === "") {
                if (rule.checkedField) {
                  let chk = document.getElementById(rule.checkedField) as HTMLInputElement;
                  if (chk && chk.checked) {
                    message += " SELECTION CHECKED \n";
                    blnValid = false;
                  }
                } else {
                  message += " TEXTBOX REQUIRED \n";
                  blnValid = false;
                }
                input.classList.add("error-border");
                if (!firstInvalidElement) firstInvalidElement = input;
              }
            } else {
              if (!input.checked && (!input.value || input.value.trim() === "" || input.value === "on")) {
                if (rule.checkedField) {
                  let chk = document.getElementById(rule.checkedField) as HTMLInputElement;
                  if (chk && chk.checked) {
                    message += " SELECTION CHECKED \n";
                    blnValid = false;
                  }
                } else {
                  message += " FIELD REQUIRED \n";
                  blnValid = false;
                }

                let skipErrorBorder = false;

                //Special Handeling for NJ ST3 Resale
                if (this.formId === 5) {
                  const checkbox1 = document.getElementById('chkBox1') as HTMLInputElement;
                  const checkbox2 = document.getElementById('chkBox2') as HTMLInputElement;
                  const checkbox3 = document.getElementById('chkBox3') as HTMLInputElement;
                  const checkbox4 = document.getElementById('chkBox4') as HTMLInputElement;
                  const checkbox5 = document.getElementById('chkBox5') as HTMLInputElement;
                
                  skipErrorBorder =
                    (checkbox1 && checkbox1.checked) ||
                    (checkbox2 && checkbox2.checked) ||
                    (checkbox3 && checkbox3.checked) ||
                    (checkbox4 && checkbox4.checked) ||
                    (checkbox5 && checkbox5.checked);
                }

                if(!skipErrorBorder){
                  input.classList.add("error-border");
                  if (!firstInvalidElement) firstInvalidElement = input;
                }
              }
            }
          } else {
            // Handle radio button group (by name)
            let allItems = Array.from(document.getElementsByName(rule.pdfFieldName)) as HTMLInputElement[];

            if (allItems.length === 0) continue;

            // Filter out disabled radios
            let enabledItems = allItems.filter((item) => !item.disabled);

            // 🔹 Skip validation entirely if all items are disabled
            if (enabledItems.length === 0) continue;

            let hasSelection = enabledItems.some(
              (item) => item.checked || (item.type === "text" && item.value.trim() !== "")
            );

            if (!hasSelection) {
              if (rule.checkedField) {
                let chk = document.getElementById(rule.checkedField) as HTMLInputElement;
                if (chk && chk.checked) {
                  message += " SELECTION CHECKED \n";
                  blnValid = false;
                }
              } else {
                blnValid = false;
                enabledItems[0].classList.add("error-border");
                if (!firstInvalidElement) firstInvalidElement = enabledItems[0];
              }
            }
          }
        }
      }
    }

    // Focus first invalid
    if (!blnValid && firstInvalidElement) {
      firstInvalidElement.focus();
    }

    return blnValid;
  }

  openModalSignature(modal) {

    let blnValid = this.checkHTMLRules();
    if (blnValid) {
      let isAttachmentRequired = this.attachAdditionalPdf;
      if (this.formId == 12) {
        const chkBox5 = document.getElementById('chkBox5') as HTMLInputElement;
        const chkBox6 = document.getElementById('chkBox6') as HTMLInputElement;
        const chkBox7 = document.getElementById('chkBox7') as HTMLInputElement;
        const chkBox8 = document.getElementById('chkBox8') as HTMLInputElement;
        isAttachmentRequired = (chkBox5?.checked || chkBox6?.checked || chkBox7?.checked || chkBox8?.checked) ?? false;
      }
      if (this.additionalPdfFile == null && isAttachmentRequired == true) {
        alert("Please attach additional PDF");
        return;
      }
      this.activeModal.open(modal, { centered: true, size: 'lg', scrollable: true, windowClass: 'customClass', ariaLabelledBy: 'modalSignatureLabel' });
    }
    else {
      this.hasErrors = true;
      alert("Please complete required certificate fields");
    }
  }

  clearRow(rowNumber: number): void {
    const id = 21 + (rowNumber - 1) * 4;
    for (let i = 0; i < 4; i++) {
      const input = document.getElementById('txtBox' + (id + i)) as HTMLInputElement;
      if (input) input.value = '';
    }
    this.calculateGrandTotal();
  }

  calculateRowTotal(index: number): number {
    const baseId = 21 + (index - 1) * 4;

    const quantityInput = document.getElementById('txtBox' + (baseId + 2)) as HTMLInputElement;
    const costInput = document.getElementById('txtBox' + (baseId + 3)) as HTMLInputElement;

    const quantity = parseFloat(quantityInput?.value || '0');
    const cost = parseFloat(costInput?.value || '0');

    if (this.isValidNumber(quantity) && this.isValidNumber(cost)) {
      return quantity * cost;
    } else {
      return 0;
    }
  }

  calculateGrandTotal(): number {
    let grandTotal = 0;

    for (let i = 1; i <= 18; i++) {
      const rowTotal = this.calculateRowTotal(i);
      grandTotal += rowTotal;
    }

    // Optionally update a field (like txtBox93) with the result
    const totalCostInput = document.getElementById('txtBox93') as HTMLInputElement;
    if (totalCostInput) {
      totalCostInput.value = grandTotal.toFixed(2);
    }

    return grandTotal;
  }

  isValidNumber(value: any): boolean {
    return !isNaN(value) && isFinite(value);
  }


  submitSignature(data) {
    if (this.emptySignaturePad == "") {
      this.emptySignaturePad = data;
    }
    if (data != this.emptySignaturePad) {
      this.sf.signatureData.setValue(data);
    }
    else {
      this.sf.signatureData.setValue("");
    }
  }

  onSignatureSubmit(modal) {
    this.signatureSubmitted = true;
    if (this.sf.signatureData.value == this.emptySignaturePad) {
      this.sf.signatureData.setValue("");
    }
    if (this.signatureForm.invalid) {
      return;
    }
    else {
      this.activeModal.dismissAll();
      this.activeModal.open(modal, { centered: true, size: 'lg', scrollable: true, backdrop: 'static', keyboard: false, ariaLabelledBy: 'modalConsentLabel' });
    }
  }

  onConsentSubmit() {
    this.consentSubmitted = true;
    if (this.consentForm.invalid) {
      return;
    }
    else {
      this.activeModal.dismissAll();
      this.submitForm();
    }
  }

  closeModal() {
    this.activeModal.dismissAll();
  }

  submitForm() {
    this.isLoading = true;
    this.isWait = true;
    // this.commonService.setCursorWait(true);
    this.data = [];
    //Get all txtBox
    for (let i = 1; i < 100; i++) {
      let txtBox: HTMLInputElement = <HTMLInputElement>document.getElementById("txtBox" + i);
      if (txtBox == null) {
        continue;
      }
      else {
        let value = txtBox.value;

        if (txtBox.type === "date" && value) {
          // value is a plain "YYYY-MM-DD" string from <input type="date">.
          // Parsing it with `new Date(value)` reads it as UTC midnight, and
          // the local getMonth()/getDate()/getFullYear() calls below then
          // shift the date back a day for any timezone behind UTC.
          // Split the string directly instead, avoiding UTC conversion.
          const [yyyy, mm, dd] = value.split('-');
          value = `${mm}/${dd}/${yyyy}`;  // Format: MM/DD/YYYY
        }
        this.data.push(<CertificateDataModel>{ field: "txtBox" + i, value: value });
      }
    }

    //Get all chkBox
    for (let i = 1; i < 100; i++) {
      let chkBox: HTMLInputElement = <HTMLInputElement>document.getElementById("chkBox" + i);
      if (chkBox == null) {
        break;
      }
      else {
        this.data.push(<CertificateDataModel>{ field: "chkBox" + i, value: chkBox.checked ? "Yes" : "No" });
      }
    }

    this.data.push(<CertificateDataModel>{ field: "PrintedName", value: this.sf.personSigning.value });
    this.data.push(<CertificateDataModel>{ field: "Title", value: this.sf.personTitle.value });

    //imgSignature
    this.data.push(<CertificateDataModel>{ field: "imgSignature", value: this.sf.signatureData.value });

    this.dateTimeNow = new Date();
    let _certificate: CertificateModelForAttachment = {
      templateName: this.templateName,
      dateSubmitted: this.dateTimeNow,
      formId: this.formId,
      data: this.data,
      attachPDF: this.additionalPdfFile
    };
    console.log(this.data);
    prefillPdf(this.pdfService, _certificate).then(result => {
      this.attachAdditionalPdf = false;
      this.additionalPdfFile = null;
      approveFillIn(this.pdfService, result.referenceNumber).then(data => {
        this.isLoading = false;
        //this.destinationFile = result.url;
        this.destinationFile = this.sanitizer.bypassSecurityTrustResourceUrl(result.url);
        this.referenceNumber = result.referenceNumber;
        this.emailRecipient = this.authService.getEmail();
        this.newFileName = result.fileName;
        this.isSummary = true;
        this.activeModal.dismissAll();
        this.commonService.setCursorWait(false);
        this.isWait = false;
      }, () => {
        this.isLoading = false;
      });

    }, () => {
      this.isLoading = false;
    });
  }


  //HTML Functions for Checkboxes
  enableControlsFunction(chk, txt, cName, txt2) {
    this._ngZone.run(() => this.enableElements(chk, txt, cName, txt2));
  }

  toggleControlsFunction(chk, txt, cName, txt2) {
    this._ngZone.run(() => this.toggleEnableElements(chk, txt, cName, txt2));
  }

  toggleSelectControlsFunction(togglename, disablename, requireCheckbox, checkboxClass) {
    this._ngZone.run(() => this.toggleSelectEnableElements(togglename, disablename, requireCheckbox, checkboxClass));
  }

  ontothenext(parent, child) {
    this._ngZone.run(() => this.ontothenextOne(parent, child));
  }

  compareDates(dateFrom, dateTo) {
    this._ngZone.run(() => this.comparetheseDates(dateFrom, dateTo));
  }

  linkData(fromData1, toData2) {
    this._ngZone.run(() => this.linktheseData(fromData1, toData2));
  }

  revertToValue(xValue, cName) {
    this._ngZone.run(() => this.revertValue(xValue, cName));
  }


  enableElements(chk, txt, cName, txt2) {
    if (chk.checked) {
      const parentLi = chk.closest('li');
      if (parentLi) {
        const elements = parentLi.getElementsByClassName(cName);
        for (let e = 0; e < elements.length; e++) {
          const input = elements[e] as HTMLInputElement;
          input.setAttribute("disabled", "disabled");
          input.value = "";
        }
      }

      if (txt != null) {
        document.getElementById(txt)?.removeAttribute("disabled");
      }
      if (txt2 != null) {
        document.getElementById(txt2)?.removeAttribute("disabled");
      }
    }
  }

  toggleEnableElements(chk, txt, cName, txt2) {
    let elements = document.getElementsByClassName(cName);
    for (let e = 0; e < elements.length; e++) {
      elements[e].setAttribute("disabled", "disabled");
      let input: HTMLInputElement = <HTMLInputElement>document.getElementById(elements[e].id);
      input.value = "";
      //special case for form ID-st101 on txtBox9
      if (cName.indexOf('skip') > 0 && txt == null) {
        input.value = "N/A";
      }
      if (input.checked == true) {
        input.checked = false;
      }
    }
    if (chk.checked) {
      if (txt != null && txt !== 'mass') {
        document.getElementById(txt).removeAttribute("disabled");
      }
      if (txt2 != null) {
        document.getElementById(txt2).removeAttribute("disabled");
      }
      if (txt == "mass") {
        let elements = document.getElementsByClassName(cName);
        for (let e = 0; e < elements.length; e++) {
          elements[e].removeAttribute("disabled");
        }
        //special case for form ID-st101 on sec5
        // if (cName == 'sec5') {
        //   let textinput: HTMLInputElement = <HTMLInputElement>document.getElementById('txtBox9');
        //   textinput.value = 'N/A';
        // }
      }
    } else {
      if (txt != null) {
        (document.getElementById(txt) as any).disabled = true;
      }
      if (txt2 != null) {
        (document.getElementById(txt2) as any).disabled = true;
      }
      if (txt == "mass") {
        let elements = document.getElementsByClassName(cName);
        for (let e = 0; e < elements.length; e++) {
          elements[e].setAttribute("disabled", "disabled");
        }
        if (txt != null) {
          (document.getElementById(txt) as any).disabled = true;
        }
      }
    }
  }

  toggleSelectEnableElements(togglename, disablename, requireCheckbox, checkboxClass) {

    //disable everything with disablename and only enable those that have togglename
    let disableElements = document.getElementsByClassName(disablename);
    for (let e = 0; e < disableElements.length; e++) {
      disableElements[e].setAttribute("disabled", "disabled");
      let input: HTMLInputElement = <HTMLInputElement>document.getElementById(disableElements[e].id);
      if (input.value !== "") {
        input.value = "";
      }
      if (input.checked == true) {
        input.checked = false;
      }
    }
    //uncheck everything
    let uncheckElements = document.getElementsByClassName(checkboxClass);
    for (let e = 0; e < uncheckElements.length; e++) {
      uncheckElements[e].removeAttribute("checked");
    }
    //checked selected
    if (requireCheckbox !== "") {
      document.getElementById(requireCheckbox).setAttribute("checked", "true");
    }
    //enable elements
    let elements = document.getElementsByClassName(togglename);
    for (let e = 0; e < elements.length; e++) {
      elements[e].removeAttribute("disabled");
    }
  }

  ontothenextOne(parent, child) {
    let parentobj: HTMLInputElement = <HTMLInputElement>document.getElementById(parent);
    let childobj = document.getElementsByClassName(child);
    if (parentobj.value !== "") {
      for (let e = 0; e < childobj.length; e++) {
        childobj[e].removeAttribute("disabled");
      }
    } else {
      for (let e = 0; e < childobj.length; e++) {
        let input: HTMLInputElement = <HTMLInputElement>document.getElementById(childobj[e].id);
        let childattr = input.getAttribute("child-data");
        if (input.value !== "" && input.type == 'text' && childattr !== "") {
          input.value = "";
          this.ontothenext(childobj[e].id, childattr);
        } else if (input.value !== "" && input.type !== 'text' && childattr !== "") {
          var dropdownList = (document.getElementById(childobj[e].id)) as HTMLSelectElement;
          dropdownList.selectedIndex = 0;
          this.ontothenext(childobj[e].id, childattr);
        }
        childobj[e].setAttribute("disabled", "disabled");
      }
    }
  }

  comparetheseDates(DateFrom, DateTo) {
    let DateFrom1: HTMLInputElement = <HTMLInputElement>document.getElementById(DateFrom);
    let DateTo1: HTMLInputElement = <HTMLInputElement>document.getElementById(DateTo);
    let error1: HTMLInputElement = <HTMLInputElement>document.getElementById("error1");
    let error2: HTMLInputElement = <HTMLInputElement>document.getElementById("error2");
    var Date1 = Date.parse(DateFrom1.value);
    var Date2 = Date.parse(DateTo1.value);
    let elements = document.getElementsByClassName("btn-primary");
    if (DateFrom1.value !== "" && DateTo1.value !== "") {
      if (!isNaN(Date1) && !isNaN(Date2)) {
        if (Date1 > Date2) {
          error1.innerHTML = "This date cannot be greater than the other date";
          for (let e = 0; e < elements.length; e++) {
            elements[e].setAttribute("disabled", "disabled");
          }
        } else {
          for (let e = 0; e < elements.length; e++) {
            error1.innerHTML = "";
            error2.innerHTML = "";
            elements[e].removeAttribute("disabled");
          }
        }
      } else {
        error1.innerHTML = "Invalid Dates";
        error2.innerHTML = "Invalid Dates";
        for (let e = 0; e < elements.length; e++) {
          elements[e].setAttribute("disabled", "disabled");
        }
      }
    }
  }

  linktheseData(fromData1, toData2) {
    let FromData: HTMLInputElement = <HTMLInputElement>document.getElementById(fromData1);
    let toData: HTMLInputElement = <HTMLInputElement>document.getElementById(toData2);

    toData.value = FromData.value;
  }

  revertValue(xValue, cName) {
    let disableElements = document.getElementsByClassName(cName);
    for (let e = 0; e < disableElements.length; e++) {
      let input: HTMLInputElement = <HTMLInputElement>document.getElementById(disableElements[e].id);
      if (input.type == "text") {
        input.value = xValue;
      }
    }
  }

  toggleScopedRadio(chk: HTMLInputElement): void {
    const cName = chk.getAttribute('data-target');
    const groupName = chk.name;

    if (!cName || !groupName) return;

    const radios = document.querySelectorAll(`input[type=radio][name="${groupName}"]`);
    radios.forEach((radio: any) => {
      const target = radio.getAttribute('data-target');
      if (target) {
        const fields = document.getElementsByClassName(target);
        for (let i = 0; i < fields.length; i++) {
          const input = fields[i] as HTMLInputElement;
          input.disabled = true;
          input.value = '';
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false;
          }
          const subGroup = input.getAttribute('data-subgroup');
          if (subGroup) {
            const subItems = document.getElementsByClassName(subGroup);
            for (let j = 0; j < subItems.length; j++) {
              const subInput = subItems[j] as HTMLInputElement;
              subInput.disabled = true;
              subInput.checked = false;
              subInput.value = '';
            }
          }
        }
      }
    });

    if (chk.checked) {
      this.toggleControlsFunction(chk, 'mass', cName, null);
    }
  }

  //   toggleSubgroupControls(chk: HTMLInputElement): void {
  //   const subgroupKey = chk.getAttribute('data-subgroup');
  //   if (!subgroupKey) return;

  //   const related = document.querySelectorAll(`[data-subgroup="${subgroupKey}"]`);

  //   related.forEach((el: any) => {
  //     el.disabled = !chk.checked;

  //     if (!chk.checked) {
  //       if (el.type === 'radio' || el.type === 'checkbox') {
  //         el.checked = false;
  //       }
  //       if (el.tagName === 'INPUT' && el.type === 'text') {
  //         el.value = '';
  //       }
  //     }
  //   });
  // }
  toggleSubgroupControls(chk: HTMLInputElement): void {
    const groupName = chk.name;
    const selectedSubgroup = chk.getAttribute('data-subgroup');

    if (!groupName) return;

    // Step 1: Disable & clear all subgroup fields from radios in this group
    const radios = document.querySelectorAll(`input[type=radio][name="${groupName}"]`);
    radios.forEach((radio: HTMLInputElement) => {
      const subgroup = radio.getAttribute('data-subgroup');
      if (subgroup) {
        const fields = document.getElementsByClassName(subgroup);
        for (let i = 0; i < fields.length; i++) {
          const input = fields[i] as HTMLInputElement;
          input.disabled = true;
          input.value = '';
          if (input.type === 'checkbox' || input.type === 'radio') {
            input.checked = false;
          }
        }
      }
    });

    // Step 2: Enable fields related to currently checked item
    if (chk.checked && selectedSubgroup) {
      const fields = document.getElementsByClassName(selectedSubgroup);
      for (let i = 0; i < fields.length; i++) {
        const input = fields[i] as HTMLInputElement;
        input.disabled = false;
      }
    }
  }
  // handleExclusiveInputChange(currentId: string, allIds: string[]): void {
  //   const current = document.getElementById(currentId) as HTMLInputElement | null;
  //   if (!current) return;

  //   const isValueFilled =
  //     current.type === "radio" || current.type === "checkbox"
  //       ? current.checked
  //       : current.value.trim() !== "";

  //   allIds.forEach(id => {
  //     if (id !== currentId) {
  //       const other = document.getElementById(id) as HTMLInputElement | null;
  //       if (other) other.disabled = isValueFilled;
  //     }
  //   });

  //   // If none have values, re-enable all
  //   const noneHaveValue = allIds.every(id => {
  //     const el = document.getElementById(id) as HTMLInputElement | null;
  //     if (!el) return true;
  //     if (el.type === "radio" || el.type === "checkbox") {
  //       return !el.checked;
  //     } else {
  //       return el.value.trim() === "";
  //     }
  //   });

  //   if (noneHaveValue) {
  //     allIds.forEach(id => {
  //       const input = document.getElementById(id) as HTMLInputElement | null;
  //       if (input) input.disabled = false;
  //     });
  //   }
  // }

  handleExclusiveInputChange(currentId: string, allIds: string[]): void {
    const current = document.getElementById(currentId) as HTMLInputElement | null;
    if (!current) return;

    const isValueFilled =
      current.type === "radio" || current.type === "checkbox"
        ? current.checked
        : current.value.trim() !== "";

    allIds.forEach(id => {
      if (id !== currentId) {
        const other = document.getElementById(id) as HTMLInputElement | null;
        if (other) {
          other.disabled = isValueFilled;

          //Clear value when disabling
          if (isValueFilled) {
            if (other.type === "radio" || other.type === "checkbox") {
              other.checked = false;
            } else {
              other.value = "";
            }
          }
        }
      }
    });

    //Check all fields including currentId for values
    const allRelevantIds = [currentId, ...allIds];

    const noneHaveValue = allRelevantIds.every(id => {
      const el = document.getElementById(id) as HTMLInputElement | null;
      if (!el) return true;
      if (el.type === "radio" || el.type === "checkbox") {
        return !el.checked;
      } else {
        return el.value.trim() === "";
      }
    });

    // Reenable all if none have values
    if (noneHaveValue) {
      allRelevantIds.forEach(id => {
        const input = document.getElementById(id) as HTMLInputElement | null;
        if (input) input.disabled = false;
      });
    }
  }

  toggleSelectDrivenControls(select: HTMLSelectElement): void {
    const selectedValue = select.value;
    const related = document.querySelectorAll('[data-enable-on]');

    related.forEach((el: any) => {
      const enableValues = el.getAttribute('data-enable-on')?.split(',') || [];
      const shouldEnable = enableValues.includes(selectedValue);

      el.disabled = !shouldEnable;

      if (!shouldEnable) {
        if (el.type === 'radio' || el.type === 'checkbox') {
          el.checked = false;
        }
        if (el.tagName === 'INPUT' && el.type === 'text') {
          el.value = '';
        }
      }
    });
  }

  // toggleCheckboxScope(chk: HTMLInputElement) {
  //   if (!chk) return;

  //   // Get target IDs from data-target (comma-separated allowed)
  //   const targets = chk.dataset.target?.split(",") || [];

  //   targets.forEach(id => {
  //     const el = document.getElementById(id.trim()) as HTMLInputElement | null;
  //     if (el) {
  //       if (chk.checked) {
  //         el.removeAttribute("disabled");
  //       } else {
  //         el.setAttribute("disabled", "disabled");
  //         el.value = "";
  //       }
  //     }
  //   });
  // }

  toggleCheckboxScope(chk: HTMLInputElement) {
    if (!chk) return;

    const target = chk.dataset.target;
    if (!target) return;

    let elements: NodeListOf<HTMLInputElement> | any;

    if (target.startsWith(".")) {
      // Toggle by class
      elements = document.querySelectorAll<HTMLInputElement>(target);
    } else {
      // Toggle by class name if no "." given
      elements = document.querySelectorAll<HTMLInputElement>("." + target);
      // Or also match ID
      const elById = document.getElementById(target) as HTMLInputElement | null;
      if (elById) {
        elements = [...elements, elById] as any;
      }
    }

    elements.forEach(el => {
      if (chk.checked) {
        el.removeAttribute("disabled");
      } else {
        el.setAttribute("disabled", "disabled");
        el.value = "";
      }
    });
  }

  onCostChange(index: number, event: Event): void {
    for (let i = 4; i <= 12; i += 2) {
      const baseId = i;

      const costInput = document.getElementById('txtBox' + (baseId)) as HTMLInputElement;
      const cost = parseFloat(costInput?.value || '0');

      if (this.isValidNumber(cost)) {
        this.totalCost += cost;
      }
      
    }
    const totalCostInput = document.getElementById('txtBox13') as HTMLInputElement;
    const cost = parseFloat(this.totalCost.toFixed(2));
    const value = cost % 1 === 0 ? cost.toString() : cost.toFixed(2);
    totalCostInput.value = value.replace(/[^\d.]/g, ''); // Remove non-digit and non-dot characters
    this.totalCost = 0;
  }

  onAdditionalPdfChange(event: Event): void {
    let file = (event.target as HTMLInputElement).files[0];
    const element = event.currentTarget as HTMLInputElement;

    if (file && file.type !== "application/pdf") {
      alert("Please upload a PDF file");
      element.value = "";
    } else {
      if (file) {
        this.additionalPdfFile = file;
      }
    }
  }
 
  // Show/hide the "Attach Additional PDF" panel for FormId 12 based on chkBox5-8 state
  setupAttachPdfCheckboxWatchers(): void {
    const ids = ['chkBox5', 'chkBox6', 'chkBox7', 'chkBox8'];
    const boxes = ids
      .map(id => document.getElementById(id) as HTMLInputElement)
      .filter(el => el != null);

    this.evaluateAttachPdfVisibility();

    boxes.forEach(box => {
      box.addEventListener('change', () => {
        this._ngZone.run(() => this.evaluateAttachPdfVisibility());
      });
    });
  }

  evaluateAttachPdfVisibility(): void {
    if (this.formId != 12) {
      this.showAttachPdfSection = true;
      return;
    }
    const chkBox5 = document.getElementById('chkBox5') as HTMLInputElement;
    const chkBox6 = document.getElementById('chkBox6') as HTMLInputElement;
    const chkBox7 = document.getElementById('chkBox7') as HTMLInputElement;
    const chkBox8 = document.getElementById('chkBox8') as HTMLInputElement;
    this.showAttachPdfSection = (chkBox5?.checked || chkBox6?.checked || chkBox7?.checked || chkBox8?.checked) ?? false;
  }
}
